<template>
  <v-row>
    <v-dialog class="mx-0" v-model="dialog" persistent max-width="900px">
      <template v-slot:activator="{ on, attrs }">
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text medium icon v-bind="attrs" v-on="on">
              <v-icon medium color="white lighten-1"> mdi-plus-circle </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-card>
        <v-row class="mx-0">
          <v-col cols="12" class="d-flex justify-center">
            <v-card-title>
              <span class="headline">Cadastro de Nota Fiscal</span>
            </v-card-title>
          </v-col>
        </v-row>
        <v-card-text>
          <v-form ref="invoice_form">
            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-text-field
                  v-model="$v.form.nf_number.$model"
                  v-mask="'#########'"
                  label="Numero da Nota Fiscal*"
                  color="red lighten-1"
                  required
                  :error-messages="errors.data.nf_number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="$v.form.acquisition_date.$model"
                      label="Data da Aquisição*"
                      prepend-icon="mdi-calendar"
                      readonly
                      color="red lighten-1"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors.data.acquisition_date"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="$v.form.acquisition_date.$model" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-select
                  v-model="$v.form.type.$model"
                  hide-details
                  :items="acquisition_types"
                  item-value="id"
                  item-text="choice"
                  label="Tipo de Aquisição*"
                  :error-messages="errors.data.type"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6">
                <v-select
                  v-model="$v.form.source.$model"
                  hide-details
                  :items="acquisition_sources"
                  item-value="id"
                  item-text="choice"
                  label="Fonte do Recurso*"
                  :error-messages="errors.data.source"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="11" sm="11" md="11" lg="11" xl="11">
                <v-select
                  v-model="$v.form.provider.$model"
                  hide-details
                  :items="providers"
                  item-value="id"
                  item-text="fantasy_name"
                  label="Fornecedor*"
                  :error-messages="errors.data.provider"
                ></v-select>
              </v-col>
              <v-col cols="1" sm="1" md="1" lg="1" xl="1">
                <NewProvider />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-file-input
                  v-model="$v.form.invoice.$model"
                  :rules="rules"
                  accept="application/pdf"
                  label="Nota Fiscal do Recurso Adiquirido*"
                  color="red lighten-1"
                  placeholder="Selecione um documento PDF"
                  show-size
                  :error-messages="errors.data.invoice"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="closeModal()"> Fechar </v-btn>
          <v-btn color="black" text @click="storeInvoice()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <InvoiceDetailing :externalAccess="true" :invoiceId="new_invoice.id" v-if="!!new_invoice.id" />
  </v-row>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import InvoiceDetailing from '@/views/invoice/components/InvoiceDetailing'
import NewProvider from '@/views/home/components/NewProvider'

export default {
  name: 'NewInvoiceForm',
  components: { InvoiceDetailing, NewProvider },
  directives: { mask },
  data: () => ({
    invoice_inserted: false,
    dialog: false,
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    rules: [(value) => !value || value.size < 2000000 || 'Aquivo deve ser menor que 2 Megas'],

    form: {
      type: '',
      source: '',
      acquisition_date: '',
      invoice: [],
      provider: '',
      nf_number: '',
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
        maxLength: 'A descrição deve ter menos de 50 caracteres',
      },
      data: {
        type: [],
        source: [],
        acquisition_date: [],
        invoice: [],
        provider: [],
        nf_number: [],
      },
    },
  }),
  validations: {
    form: {
      nf_number: { required },
      type: { required },
      source: { required },
      acquisition_date: { required },
      invoice: { required },
      provider: { required },
    },
  },
  computed: {
    ...mapState('acquisitions', ['acquisition_types']),
    ...mapState('acquisitions', ['acquisition_sources']),
    ...mapState('acquisitions', ['providers']),
    ...mapState('acquisitions', ['new_invoice']),
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('acquisitions', ['ActionStoreInvoice']),

    closeModal() {
      this.$refs.invoice_form.reset()
      this.dialog = false
    },
    async storeInvoice() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          treated_form.append('files', this.form.invoice, this.form.invoice.name)
          treated_form.append('type', this.form.type)
          treated_form.append('nf_number', this.form.nf_number)
          treated_form.append('source', this.form.source)
          treated_form.append('acquisition_date', this.form.acquisition_date)
          treated_form.append('provider', this.form.provider)

          await this.ActionStoreInvoice(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Nota fiscal cadastrada com sucesso',
          })
          this.closeModal()
          this.invoice_inserted = true
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }
      this.ActionSetLoading(false)
    },
    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>